module.exports = __webpack_public_path__ + "img/20230928-191457.8b9813d3.jpg";